import React from "react"
import ReactMarkdown from "react-markdown"
import { graphql } from "gatsby"
import NewsItemLong from "../components/NewsItemLong"
import LayoutGeneric from "../components/LayoutGeneric"
import Seo from "../components/Seo"

export default function News({data}) {

  const { image, title, subtitle, content, SEO } = data.page;
  const { nodes:blogs } = data.allStrapiBlogs;
  // console.log(data); 

  return (
    <LayoutGeneric title={title} subtitle={subtitle} image={image.childImageSharp.gatsbyImageData}>
        <Seo 
        title={(SEO && SEO.title) ? SEO.title : title}
        description={(SEO && SEO.description) ? SEO.description : undefined }
        />
        <ReactMarkdown source={content} linkTarget="_blank"/>
        {/* <NewsList  items={blogs} listType="long" /> */}
        <ul className="gs-news-list-long">
          {blogs.map((newsItem)=>{
            return <NewsItemLong key={newsItem.id} {...newsItem}/>
          })}
        </ul>
    </LayoutGeneric>
  );
}

export const query = graphql`
  {
    page: strapiPages(slug: { eq: "news" }) {
      content
      image {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
      slug
      subtitle
      title
      id
      SEO {
        title
        description
      }
    }
    allStrapiBlogs(
      sort: { fields: date, order: DESC }
      filter: { hidden: { ne: true } }
    ) {
      nodes {
        date(formatString: "MMMM Do, YYYY")
        category
        id
        slug
        title
        desc
        image {
          childImageSharp {
            gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
          }
        }
      }
    }
  }
`
